<template>
	<div class="advantage">
		<p class="advantage_top">技术优势</p>
		<div class="advantage_wrap">
			<div class="advantage_wrap_botton1">
				<div class="advantage_wrap_botton1_left">
					<p class="advantage_wrap_botton1_leftt_p1">数据安全高</p>
					<p class="advantage_wrap_botton1_leftt_p2">
						全量/增量/日志三级备份机制、任意时间节点数据追溯能力</p>
				</div>
				<div class="advantage_wrap_botton1_right">
					<img class="safe-img" :src="safeBackground"/>
				</div>
			</div>
			<div class="advantage_wrap_botton2">
				<div class="advantage_wrap_botton2_left">
					<p class="advantage_wrap_botton2_left_p1">业务无中断</p>
					<p class="advantage_wrap_botton2_left_p2">
						分钟级RTO/RPO指标、故障自动切换演练</p>
				</div>
				<div class="advantage_wrap_botton2_right">
					<img class="icon-img" :src="tuoyuan"/>
				</div>
			</div>
			<div class="advantage_wrap_botton3">
				<div class="advantage_wrap_botton3_left">
					<p class="advantage_wrap_botton3_left_p1">合规审计</p>
					<p class="advantage_wrap_botton3_left_p2">
						等保2.0合规架构、全流程可视化审计追踪</p>
				</div>
				<div class="advantage_wrap_botton3_right">
					<img class="manage-img" :src="manageBackground"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Advantage",
	data() {
		return {
			safeBackground: require('@/assets/advantage/safe.png'),
			manageBackground: require('@/assets/advantage/manage.png'),
			tuoyuan: require('@/assets/advantage/tuoyuan.png')
		}
	},
	methods: {},
	created() {

	},
	computed: {},
	watch: {},

}
</script>

<style lang="scss" scoped>
.advantage {
	width: 1920px;
	height: 495px;
}

.advantage_top {
	padding-top: 70px;
	width: 100%;
	height: 47px;
	/** 文本1 */
	font-size: 32px;
	font-weight: 700;
	letter-spacing: 0;
	line-height: 46.34px;
	color: rgba(34, 34, 34, 1);
	text-align: center;
	vertical-align: top;
}

.advantage_wrap {
	/* 子元素水平居中 */
	display: flex;
	justify-content: center;
	padding-top: 44px;
}

.advantage_wrap_botton1 {
	width: 440px;
	height: 262px;
	margin-right: 40px;
	background: rgba(245, 248, 255, 1);
}

.advantage_wrap_botton2 {
	width: 440px;
	height: 262px;
	margin-right: 38px;
	background: linear-gradient(270deg, rgba(112, 168, 64, 1) 0%, rgba(13, 126, 191, 1) 100%);
}

.advantage_wrap_botton3 {
	width: 440px;
	height: 262px;
	background: rgba(245, 248, 255, 1);
}

.advantage_wrap_botton1_left {
	float: left;
	width: 250px;
	height: 202px;
	margin-left: 41px;
	margin-top: 34px;
}

.advantage_wrap_botton1_right {
	float: left;
	width: 64px;
	height: 76px;
	margin-top: 165px;
	margin-left: 56px;
  .safe-img {
    width: 64px;
    height: 76px;
  }
}

.advantage_wrap_botton1_leftt_p1 {
	width: 100%;
	height: 35px;
	/** 文本1 */
	font-size: 24px;
	font-weight: 400;
	letter-spacing: 0;
	line-height: 34.75px;
	color: rgba(51, 51, 51, 1);
	text-align: left;
	vertical-align: top;
}

.advantage_wrap_botton1_leftt_p2 {
	margin-top: 11px;
	width: 248px;
	height: 155.67px;
	/** 文本1 */
	font-size: 14px;
	font-weight: 300;
	letter-spacing: 0;
	line-height: 20.27px;
	color: rgba(102, 102, 102, 1);
	text-align: left;
	vertical-align: top;
}

.advantage_wrap_botton2_left {
	float: left;
	margin-top: 33px;
	margin-left: 41px;
	width: 248px;
	height: 178px;
}

.advantage_wrap_botton2_right {
	float: left;
	margin-top: 161px;
	margin-left: 47px;
	width: 79px;
	height: 82px;
  .icon-img {
    width: 79px;
    height: 82px;
  }
}

.advantage_wrap_botton2_left_p1 {
	width: 100%;
	height: 35px;
	/** 文本1 */
	font-size: 24px;
	font-weight: 400;
	letter-spacing: 0;
	line-height: 34.75px;
	color: rgba(255, 255, 255, 1);
	text-align: left;
	vertical-align: top;
}

.advantage_wrap_botton2_left_p2 {
	margin-top: 11px;
	width: 248px;
	height: 131.91px;
	/** 文本1 */
	font-size: 14px;
	font-weight: 300;
	letter-spacing: 0;
	line-height: 20.27px;
	color: rgba(255, 255, 255, 1);
	text-align: left;
	vertical-align: top;
}

.advantage_wrap_botton3_left {
	float: left;
	margin-top: 33px;
	margin-left: 42px;
	width: 248px;
	height: 203px;
}

.advantage_wrap_botton3_right {
	float: left;
	margin-left: 60px;
	margin-top: 172px;
	width: 65px;
	height: 65px;
  .manage-img {
    width: 65px;
    height: 65px;
  }
}

.advantage_wrap_botton3_left_p1 {
	width: 100%;
	height: 35px;
	/** 文本1 */
	font-size: 24px;
	font-weight: 400;
	letter-spacing: 0;
	line-height: 34.75px;
	color: rgba(51, 51, 51, 1);
	text-align: left;
	vertical-align: top;
}

.advantage_wrap_botton3_left_p2 {
	margin-top: 11px;
	width: 248px;
	height: 156.91px;
	/** 文本1 */
	font-size: 14px;
	font-weight: 300;
	letter-spacing: 0;
	line-height: 20.27px;
	color: rgba(102, 102, 102, 1);
	text-align: left;
	vertical-align: top;
}
</style>